import deepmerge from "@node/deepmerge";

let locales = {};
const modules = import.meta.glob("@o-din-report/../../config/locales/**/*.yml", { eager: true });

for (const path in modules) {
  locales = deepmerge(locales, modules[path].default);
}

import store from "@o-din-report/src/report/store.js";
import menu from "@o-din-report/src/report/menu.json";

export default {
  routes: [
    { path: '/report/maintenance', component: () => import("./views/report/maintenance/Maintenance.vue") },
    { path: '/report/ppr', component: () => import("./views/report/ppr/Ppr.vue") },
    { path: '/report/round', component: () => import("./views/report/rounds/Round.vue") }
  ],
  locales,
  store,
  menu: [menu]
}
